import React from 'react';

interface PurchaserIconProps {
    classes?: string;
}

export const PurchaserIcon = ({ classes }: PurchaserIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 12.5C11.0717 12.5 10.1815 12.8687 9.52513 13.5251C8.86875 14.1815 8.5 15.0717 8.5 16C8.5 16.9283 8.86875 17.8185 9.52513 18.4749C10.1815 19.1313 11.0717 19.5 12 19.5C12.9283 19.5 13.8185 19.1313 14.4749 18.4749C15.1313 17.8185 15.5 16.9283 15.5 16C15.5 15.0717 15.1313 14.1815 14.4749 13.5251C13.8185 12.8687 12.9283 12.5 12 12.5ZM10.5 16C10.5 15.6022 10.658 15.2206 10.9393 14.9393C11.2206 14.658 11.6022 14.5 12 14.5C12.3978 14.5 12.7794 14.658 13.0607 14.9393C13.342 15.2206 13.5 15.6022 13.5 16C13.5 16.3978 13.342 16.7794 13.0607 17.0607C12.7794 17.342 12.3978 17.5 12 17.5C11.6022 17.5 11.2206 17.342 10.9393 17.0607C10.658 16.7794 10.5 16.3978 10.5 16Z"
                fill="#00AEEF"
            />
            <path
                d="M17.526 5.11716L14.347 0.660156L2.658 9.99816L2.01 9.99116V10.0012H1.5V22.0012H22.5V10.0012H21.538L19.624 4.40216L17.526 5.11716ZM19.425 10.0012H9.397L16.866 7.45516L18.388 6.96816L19.425 10.0012ZM15.55 5.79116L7.84 8.41916L13.946 3.54116L15.55 5.79116ZM3.5 18.1702V13.8302C3.92218 13.6812 4.30565 13.4396 4.62231 13.1231C4.93896 12.8066 5.18077 12.4233 5.33 12.0012H18.67C18.8191 12.4234 19.0609 12.807 19.3775 13.1236C19.6942 13.4403 20.0777 13.6821 20.5 13.8312V18.1712C20.0777 18.3203 19.6942 18.562 19.3775 18.8787C19.0609 19.1953 18.8191 19.5789 18.67 20.0012H5.332C5.18218 19.5788 4.93996 19.1953 4.62302 18.8785C4.30607 18.5618 3.9224 18.3197 3.5 18.1702Z"
                fill="#00AEEF"
            />
        </svg>
    );
};
